// The hub sections: home-page tiles, drawer entries and app-bar titles all derive
// from this single list so the three stay in sync.

import { ChartColumn, HandHeart, Users } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface HubSection {
  href: string;
  label: string;
  icon: LucideIcon;
  /** Colored icon circle on the home grid (light + dark). */
  tileClass: string;
  /** False → served by the shared ComingSoon page. */
  ready: boolean;
}

export const HUB_SECTIONS: HubSection[] = [
  {
    href: "/donations",
    label: "Donations",
    icon: HandHeart,
    tileClass: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
    ready: true,
  },
  {
    href: "/donors",
    label: "Donors",
    icon: Users,
    tileClass: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300",
    ready: true,
  },
  {
    href: "/reports",
    label: "Reports",
    icon: ChartColumn,
    tileClass: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300",
    ready: true,
  },
];

export const APP_NAME = "RGSEVA Donations";

interface SectionBar {
  title: string;
  /** Where the app-bar back arrow goes. */
  back: string;
}

/**
 * App-bar title + back target for the current route. `null` means the home hub
 * (app name, hamburger, no back arrow).
 */
export function sectionBar(pathname: string): SectionBar | null {
  if (pathname === "/") return null;
  if (/^\/donors\/\d+$/.test(pathname)) return { title: "Donor", back: "/" };
  if (pathname === "/donations/new") return { title: "New donation", back: "/donations" };
  const section = HUB_SECTIONS.find((s) => pathname === s.href || pathname.startsWith(`${s.href}/`));
  if (section) return { title: section.label, back: "/" };
  return { title: APP_NAME, back: "/" };
}
